import React from 'react'

import { Icon, IconNotebook, palette } from '@centivo/react-components'
import styled from 'styled-components'

export interface IconDisplayProps {
  icon: IconNotebook
  color?: string
  marginTop?: string
}

const Display = styled.p<{ marginTop?: string }>`
  font-size: 1rem;
  line-height: 1.5rem;
  vertical-align: middle;
  margin-top: ${({ marginTop = '0.25rem' }) => marginTop};

  > svg,
  > span {
    line-height: inherit;
    vertical-align: middle;
  }

  > svg {
    margin-right: 0.5rem;
  }
`

export const IconDisplay: React.FC<IconDisplayProps> = ({
  icon,
  children,
  marginTop,
  color = palette.brand.teal,
}) => (
  <Display marginTop={marginTop}>
    <Icon color={color} icon={icon} size="1.5rem" aria-hidden />
    <span>{children}</span>
  </Display>
)
